<template>
  <section
    v-if="lineItems?.length"
    :data-e2e="TaxCypressAttribute.probateCalculator.views.BREAKDOWN"
  >
    <Collapse :show-icon="false" :is-borderless="true" :open="false">
      <template #header>
        <div class="is-full-width has-text-primary is-flex-centered">
          <span class="has-text-weight-semibold">
            {{ $t('tax.calculator-breakdown') }}
          </span>
          <i class="icon cls cls-caret-down"></i>
        </div>
      </template>
      <section class="is-flex is-justify-content-center">
        <div>
          <Table
            :hide-table-control="true"
            :predefined-data="lineItems"
            :columns="columns"
            :display-table-header="false"
            :show-mobile-cards="false"
          >
            <template #identifier="{ rowData }">
              <TagView class="m-l-2" type="is-light" v-if="rowData.letterIdentifier">
                {{ rowData.letterIdentifier }}
              </TagView>
            </template>
          </Table>
        </div>
      </section>
    </Collapse>
  </section>
</template>

<script>
import Collapse from '/@/modules/core/app/components/Collapse.vue';
import Table from '/@/modules/core/table/components/Table.vue';
import { ProbateCalculatorBreakdownColumns } from '@/modules/tax/models/ProbateCalculatorBreakdownColumns';
import { TaxCypressAttribute } from '@/modules/tax/constants/TaxCypressAttribute';
import TagView from '@/modules/core/ui/components/wrappers/TagView.vue';

export default {
  compatConfig: {
    COMPONENT_V_MODEL: true
  },
  name: 'ProbateCalculatorBreakdown',
  components: {
    TagView,
    Collapse,
    Table
  },
  props: {
    lineItems: {
      type: Array
    }
  },
  static: {
    TaxCypressAttribute,
    columns: new ProbateCalculatorBreakdownColumns()
  }
};
</script>
